<div class="n-recuperar-senha-page">
  <div class="n-container">
    <!-- Logo -->
    <div class="n-logo-container">
      <object
        class="n-logo"
        data="assets/icons/nomoh_logo.svg"
        type="image/svg+xml"
      ></object>
    </div>

    <!-- Card Principal -->
    <div class="n-card">
      <p-stepper [(activeStep)]="active" class="n-stepper">
        <!-- ETAPA 1: Informar Contato -->
        <p-stepperPanel>
          <ng-template pTemplate="header" let-index="index">
            <span
              class="n-step-icon"
              [ngClass]="{
                'n-step-active': index <= active,
                'n-step-inactive': index > active
              }"
            >
              <i class="pi pi-user"></i>
            </span>
          </ng-template>

          <ng-template pTemplate="content" let-nextCallback="nextCallback">
            <div class="n-step-content">
              <!-- Cabeçalho da Etapa -->
              <div class="n-step-header">
                <h2 class="n-title-large">
                  {{ "PAGINA_RECUPERAR_SENHA.ETAPA_1.TITULO" | translate }}
                </h2>
                <p class="n-body-large">
                  {{ "PAGINA_RECUPERAR_SENHA.ETAPA_1.MENSAGEM" | translate }}
                </p>
              </div>

              <!-- Toggle Tipo de Recuperação -->
              <div class="n-contact-type-toggle">
                <div class="n-toggle-container">
                  <div class="n-toggle-label">Recuperar por:</div>
                  <div class="n-toggle-options">
                    <button
                      type="button"
                      class="n-toggle-option"
                      [ngClass]="{
                        'n-toggle-active': tipoRecuperacao() === 'telefone'
                      }"
                      (click)="
                        tipoRecuperacao() !== 'telefone' &&
                          alternarTipoRecuperacao()
                      "
                    >
                      <i class="pi pi-phone"></i>
                      <span>Telefone</span>
                    </button>
                    <button
                      type="button"
                      class="n-toggle-option"
                      [ngClass]="{
                        'n-toggle-active': tipoRecuperacao() === 'email'
                      }"
                      (click)="
                        tipoRecuperacao() !== 'email' &&
                          alternarTipoRecuperacao()
                      "
                    >
                      <i class="pi pi-envelope"></i>
                      <span>E-mail</span>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Formulário -->
              <form [formGroup]="formContato" class="n-form-section">
                <div class="n-field-group">
                  <!-- Campo Telefone -->
                  <div
                    class="n-field n-field-full n-field-animated"
                    [ngClass]="{
                      'n-field-hidden': tipoRecuperacao() !== 'telefone'
                    }"
                    *ngIf="tipoRecuperacao() === 'telefone'"
                  >
                    <app-form-field
                      label="{{
                        'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.TELEFONE'
                          | translate
                      }}"
                      controlName="telefone"
                      [required]="true"
                    >
                      <p-inputMask
                        formControlName="telefone"
                        mask="(99) 99999-9999"
                        [placeholder]="placeholderContato"
                        [autocomplete]="autocompleteContato"
                      ></p-inputMask>
                    </app-form-field>
                  </div>

                  <!-- Campo E-mail -->
                  <div
                    class="n-field n-field-full n-field-animated"
                    [ngClass]="{
                      'n-field-hidden': tipoRecuperacao() !== 'email'
                    }"
                    *ngIf="tipoRecuperacao() === 'email'"
                  >
                    <app-form-field
                      label="{{
                        'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.EMAIL' | translate
                      }}"
                      controlName="email"
                      [required]="true"
                    >
                      <input
                        pInputText
                        formControlName="email"
                        type="email"
                        [placeholder]="placeholderContato"
                        [autocomplete]="autocompleteContato"
                      />
                    </app-form-field>
                  </div>
                </div>
              </form>

              <!-- Ações -->
              <div class="n-form-actions">
                <p-button
                  [label]="'BOTAO.VOLTAR' | translate"
                  styleClass="n-button-sec"
                  (click)="cancelar()"
                  icon="pi pi-arrow-left"
                />
                <p-button
                  [label]="'PAGINA_RECUPERAR_SENHA.BOTAO.PROXIMO' | translate"
                  styleClass="n-button-prim"
                  (click)="onSubmitContato()"
                  [disabled]="!campoContatoValido"
                  [loading]="isBotaoSalvar"
                  icon="pi pi-arrow-right"
                  iconPos="right"
                />
              </div>
            </div>
          </ng-template>
        </p-stepperPanel>

        <!-- ETAPA 2: Token e Nova Senha -->
        <p-stepperPanel>
          <ng-template pTemplate="header" let-index="index">
            <span
              class="n-step-icon"
              [ngClass]="{
                'n-step-active': index <= active,
                'n-step-inactive': index > active
              }"
            >
              <i class="pi pi-shield"></i>
            </span>
          </ng-template>

          <ng-template pTemplate="content" let-prevCallback="prevCallback">
            <div class="n-step-content">
              <!-- Cabeçalho da Etapa -->
              <div class="n-step-header">
                <h2 class="n-title-large">
                  {{ "PAGINA_RECUPERAR_SENHA.ETAPA_2.TITULO" | translate }}
                </h2>
                <p class="n-body-large">
                  {{ "PAGINA_RECUPERAR_SENHA.ETAPA_2.MENSAGEM" | translate }}
                  <span class="n-contact-info">
                    {{
                      tipoRecuperacao() === "telefone"
                        ? formContato.get("telefone")?.value
                        : formContato.get("email")?.value
                    }}
                  </span>
                </p>
              </div>

              <!-- Formulário -->
              <form [formGroup]="formTokenSenhas" class="n-form-section">
                <div class="n-field-group">
                  <!-- Token de Verificação -->
                  <div class="n-field n-field-full">
                    <app-form-field
                      label="{{
                        'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.CODIGO_VERIFICACAO'
                          | translate
                      }}"
                      controlName="token"
                      [required]="true"
                      [helpText]="
                        'Digite o código de 6 dígitos enviado para seu ' +
                        textoTipoRecuperacao.toLowerCase()
                      "
                    >
                      <input
                        pInputText
                        pKeyFilter="num"
                        id="token"
                        formControlName="token"
                        autocomplete="one-time-code"
                        maxlength="6"
                        placeholder="000000"
                        class="w-full n-token-input"
                      />
                    </app-form-field>
                  </div>

                  <!-- Nova Senha -->
                  <div class="n-field n-field-full">
                    <app-form-field
                      label="{{
                        'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.SENHA' | translate
                      }}"
                      controlName="senha"
                      [required]="true"
                    >
                      <p-password
                        formControlName="senha"
                        autocomplete="new-password"
                        [toggleMask]="true"
                        placeholder="Digite sua nova senha"
                        [feedback]="true"
                        styleClass="w-full"
                      >
                        <ng-template pTemplate="footer">
                          <div class="n-password-requirements">
                            <p class="n-requirements-title">
                              A senha deve conter pelo menos:
                            </p>
                            <ul class="n-requirements-list">
                              <li
                                class="n-requirement-item"
                                [ngClass]="{
                                  'n-requirement-valid': hasUpperCase()
                                }"
                              >
                                <i
                                  class="pi"
                                  [ngClass]="
                                    hasUpperCase() ? 'pi-check' : 'pi-times'
                                  "
                                ></i>
                                Uma letra maiúscula
                              </li>
                              <li
                                class="n-requirement-item"
                                [ngClass]="{
                                  'n-requirement-valid': hasLowerCase()
                                }"
                              >
                                <i
                                  class="pi"
                                  [ngClass]="
                                    hasLowerCase() ? 'pi-check' : 'pi-times'
                                  "
                                ></i>
                                Uma letra minúscula
                              </li>
                              <li
                                class="n-requirement-item"
                                [ngClass]="{
                                  'n-requirement-valid': hasNumber()
                                }"
                              >
                                <i
                                  class="pi"
                                  [ngClass]="
                                    hasNumber() ? 'pi-check' : 'pi-times'
                                  "
                                ></i>
                                Um número
                              </li>
                              <li
                                class="n-requirement-item"
                                [ngClass]="{
                                  'n-requirement-valid': hasSpecialChar()
                                }"
                              >
                                <i
                                  class="pi"
                                  [ngClass]="
                                    hasSpecialChar() ? 'pi-check' : 'pi-times'
                                  "
                                ></i>
                                Um caractere especial (#, $, etc)
                              </li>
                              <li
                                class="n-requirement-item"
                                [ngClass]="{
                                  'n-requirement-valid': hasMinLength()
                                }"
                              >
                                <i
                                  class="pi"
                                  [ngClass]="
                                    hasMinLength() ? 'pi-check' : 'pi-times'
                                  "
                                ></i>
                                8 caracteres no mínimo
                              </li>
                            </ul>
                          </div>
                        </ng-template>
                      </p-password>
                    </app-form-field>
                  </div>

                  <!-- Confirmar Senha -->
                  <div class="n-field n-field-full">
                    <app-form-field
                      label="{{
                        'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.CONFIRMAR_SENHA'
                          | translate
                      }}"
                      controlName="confirmarSenha"
                      [required]="true"
                    >
                      <input
                        pInputText
                        id="confirmPassword"
                        formControlName="confirmarSenha"
                        autocomplete="new-password"
                        type="password"
                        placeholder="Confirme sua nova senha"
                        class="w-full"
                      />
                    </app-form-field>

                    <!-- Indicador de senhas iguais -->
                    <div
                      class="n-password-match-indicator"
                      *ngIf="formTokenSenhas.get('confirmarSenha')?.value"
                    >
                      <div
                        class="n-match-status"
                        [ngClass]="{
                          'n-match-valid': senhasIguais,
                          'n-match-invalid': !senhasIguais
                        }"
                      >
                        <i
                          class="pi"
                          [ngClass]="senhasIguais ? 'pi-check' : 'pi-times'"
                        ></i>
                        <span>
                          {{
                            senhasIguais
                              ? "Senhas coincidem"
                              : "Senhas não coincidem"
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <!-- Ações -->
              <div class="n-form-actions">
                <p-button
                  [label]="'BOTAO.VOLTAR' | translate"
                  styleClass="n-button-sec"
                  (click)="voltarEtapa()"
                  icon="pi pi-arrow-left"
                />
                <p-button
                  [label]="
                    'PAGINA_RECUPERAR_SENHA.ETAPA_2.ALTERAR_SENHA' | translate
                  "
                  styleClass="n-button-prim"
                  (click)="onSubmitTokenSenha()"
                  [disabled]="!formTokenSenhas.valid"
                  [loading]="isBotaoSalvar"
                  icon="pi pi-check"
                  iconPos="right"
                />
              </div>
            </div>
          </ng-template>
        </p-stepperPanel>
      </p-stepper>
    </div>

    <!-- Link para voltar ao login -->
    <div class="n-login-link">
      <p class="n-body-medium">
        Lembrou da senha?
        <a href="#" (click)="cancelar()" class="n-link">Fazer login</a>
      </p>
    </div>
  </div>
</div>

<!-- Modal de Confirmação -->
<p-confirmDialog #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="n-confirm-dialog">
      <div class="n-confirm-icon">
        <i class="pi pi-check-circle"></i>
      </div>
      <h3 class="n-confirm-title">{{ message.header }}</h3>
      <p class="n-confirm-message">{{ message.message }}</p>
      <div class="n-confirm-actions">
        <p-button label="OK" styleClass="n-button-prim" (click)="cd.accept()" />
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
